import { roleApi, userApi } from '../../api/accountsApi'; 
import dayjs from 'dayjs';
import { User } from '../../types/users.types';
import { Role } from '../../types/roles.types';

export interface DashboardData {
  users: User[];
  roles: Role[];
}

// Utility to filter users by date range
export const filterUsersByDate = (users: User[], startDate: dayjs.Dayjs): User[] => {
  return users.filter(user => dayjs(user.createdAt).isAfter(startDate));
};

// Utility to count users by status
export const countUsersByStatus = (users: User[], status: string): number => {
  return users.filter(user => user.status === status).length;
};

// Utility to count roles with user counts
export const countRolesWithUsers = (users: User[]): { role: string; count: number }[] => {
  const roleCounts: Record<string, number> = {};
  users.forEach(user => {
    const roleName = user.role?.name || 'Unknown';
    roleCounts[roleName] = (roleCounts[roleName] || 0) + 1;
  });
  return Object.entries(roleCounts).map(([role, count]) => ({ role, count }));
};

// Fetch dashboard data
export const fetchDashboardData = async () => {
  try {
    const [usersResponse, rolesResponse] = await Promise.all([
      userApi.fetchAll(),
      roleApi.fetchAll(),
    ]); 
    console.log('Dashboard fetch responses:', usersResponse.data);
    const users = usersResponse.data || []
    return {
      users: usersResponse.data || [], // Ensure we return an array
      roles: rolesResponse.data || [], // Ensure we return an array
    };
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    return null;
  }
};